import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css'
import './fonts/fonts.css'
import './fonts/font-awesome.min.css'
import animated from 'animate.css'
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: '8WpKbN21gwwyGs22agHfCPeBWnTigGOv'
})

Vue.use(ElementUI);
Vue.use(animated)


Vue.config.productionTip = false

axios.defaults.baseURL = 'http://boyang.sansg.com';
Vue.prototype.$$axios = axios

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
